import React, {useState} from 'react';
import {Button, Dialog} from '@rneui/themed';
import {createStyles} from '../../utils/createStyles';
import {Image, Text, View} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

export type ButtonStyle = {
  color?: string;
  backgroundColor?: string | Array<string>;
};

export let showConfirmDialog: (options: DialogOptions) => void = () => {};
export let hideConfirmDialog: () => void = () => {};

export type DialogOptions = {
  content?: string;
  icon?: string;
  type?: 'error' | 'info' | 'success' | 'warning';
  confirmText?: string;
  cancelText?: string;
  showCancel?: boolean;
  confirmButtonStyle?: ButtonStyle;
  cancelButtonStyle?: ButtonStyle;
  confirmCallback?: (close: () => void) => void;
  cancelCallback?: (close: () => void) => void;
};

export default function ConfirmDialog(): React.JSX.Element {
  const defaultOptions: DialogOptions = {
    showCancel: true,
  };
  const [dialogVisible, setDialogVisible] = useState(false);
  const [options, setOptions] = useState<DialogOptions>(defaultOptions);

  showConfirmDialog = (dialogOptions: DialogOptions) => {
    setOptions({
      ...defaultOptions,
      ...dialogOptions,
    });
    setDialogVisible(true);
  };
  hideConfirmDialog = () => {
    setDialogVisible(false);
  };

  const close = () => {
    setDialogVisible(false);
  };
  const onCancel = () => {
    if (options.cancelCallback) {
      options.cancelCallback(close);
    } else {
      close();
    }
  };
  const onConfirm = () => {
    if (options.confirmCallback) {
      options.confirmCallback(close);
    } else {
      close();
    }
  };

  const icons = {
    error: require('../../assets/images/dialog/error.png'),
    info: require('../../assets/images/dialog/info.png'),
    success: require('../../assets/images/dialog/info.png'),
    warning: require('../../assets/images/dialog/info.png'),
  };

  const confirmButtonStyle = {
    color: options.confirmButtonStyle?.color || '#fff',
    backgroundColor: options.confirmButtonStyle?.backgroundColor || '#6455FF',
  };

  const cancelButtonStyle = {
    color: options.cancelButtonStyle?.color || '#333',
    backgroundColor: options.cancelButtonStyle?.backgroundColor || '#ECF2FF',
  };

  const getLineColors = (color: string | Array<string>) => {
    if (typeof color === 'string') {
      return [color, color];
    } else {
      return color;
    }
  };
  return (
    <Dialog
      overlayStyle={styles.overlayStyle}
      isVisible={dialogVisible}
      supportedOrientations={['landscape', 'portrait']}
      transparent
      statusBarTranslucent={true}>
      <View style={styles.dialogWrap}>
        <View style={styles.contentWrap}>
          <View style={styles.iconWrap}>
            <Image
              style={styles.iconImage}
              source={
                options.icon
                  ? {
                      uri: options.icon,
                    }
                  : icons[options.type || 'info']
              }
            />
          </View>
          <View style={styles.textWrap}>
            <Text style={styles.text}>{options.content}</Text>
          </View>
        </View>
        <View
          style={[
            styles.dialogBts,
            {justifyContent: options.showCancel ? 'space-between' : 'center'},
          ]}>
          {options.showCancel ? (
            <Button
              activeOpacity={0.8}
              ViewComponent={LinearGradient}
              onPress={() => onCancel()}
              linearGradientProps={{
                style: {height: '100%', flex: 1},
                colors: getLineColors(cancelButtonStyle.backgroundColor),
                start: {x: 0, y: 0.5},
                end: {x: 1, y: 0.5},
              }}
              buttonStyle={styles.dialogCancelButton}>
              <Text
                style={[
                  styles.dialogCancelButtonText,
                  {
                    color: cancelButtonStyle.color,
                  },
                ]}>
                {options.cancelText || '取消'}
              </Text>
            </Button>
          ) : null}
          <Button
            activeOpacity={0.8}
            ViewComponent={LinearGradient}
            onPress={() => onConfirm()}
            linearGradientProps={{
              style: {height: '100%', flex: 1},
              colors: getLineColors(confirmButtonStyle.backgroundColor),
              start: {x: 0, y: 0.5},
              end: {x: 1, y: 0.5},
            }}
            buttonStyle={styles.dialogConfirmButton}>
            <Text
              style={[
                styles.dialogConfirmButtonText,
                {
                  color: confirmButtonStyle.color,
                },
              ]}>
              {options.confirmText || '确定'}
            </Text>
          </Button>
        </View>
      </View>
    </Dialog>
  );
}
const styles = createStyles({
  overlayStyle: {
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    elevation: 0,
    shadowColor: 'transparent',
  },
  dialogWrap: {
    width: '35rem',
    borderRadius: '1.7rem',
    padding: '1.6rem',
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentWrap: {
    marginVertical: '3.5rem',
    paddingHorizontal: '3rem',
    flexDirection: 'row',
  },
  iconWrap: {
    width: '2.6rem',
    height: '2.6rem',
    marginRight: '0.75rem',
  },
  iconImage: {
    width: '100%',
    height: '100%',
  },
  textWrap: {},
  text: {
    fontSize: '1.7rem',
    color: '#3D3D3D',
  },
  dialogBts: {
    width: '100%',
    paddingHorizontal: '1.2rem',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dialogCancelButton: {
    width: '13.5rem',
    height: '4.5rem',
    borderRadius: '3.25rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogCancelButtonText: {
    fontSize: '1.5rem',
  },
  dialogConfirmButton: {
    width: '13.5rem',
    height: '4.5rem',
    borderRadius: '3.25rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dialogConfirmButtonText: {
    fontSize: '1.5rem',
  },
});
